module.exports = __webpack_public_path__ + "static/Currency_hires-17408567d7c8e1af21a034b85841faef.jpg";